import { initialGeneralState } from 'redux/initialState';
import { status } from 'constants/general';

import generalActionTypes from './action-types';

const generalReducer = (state = initialGeneralState, { type, payload }) => {
  switch (type) {
    case generalActionTypes.FETCH_CAMPAIGNS_INSIGHTS:
      return {
        ...state,
        campaignsInsights: {
          status: status.FETCHING,
        },
      };

    case generalActionTypes.FETCH_CAMPAIGNS_INSIGHTS_SUCCESS:
      return {
        ...state,
        campaignsInsights: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case generalActionTypes.FETCH_CAMPAIGNS_INSIGHTS_FAIL:
      return {
        ...state,
        campaignsInsights: {
          status: status.FAIL,
        },
      };

    default:
      return state;
  }
};

export default generalReducer;
